<template>
  <Row>
<!--    <Col :span="9">-->
<!--      <CellGroup inset>-->
<!--        <Field v-model="SearchQuery.likeQuery.order_number" center placeholder="订单编号" clearable="true"/>-->
<!--      </CellGroup>-->
<!--    </Col>-->
    <Col :span="18">
      <CellGroup inset>
        <Field v-model="SearchQuery.likeQuery.month" center placeholder="月份" @click="show = true" clearable/>
      </CellGroup>
    </Col>
    <Col :span="6">
      <Button icon="search" color="var(--base-color)" @click="search" style="border-radius:5px">搜索</Button>
    </Col>
  </Row>

  <List
      v-model:loading="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      style="margin-top: 10px"
  >
    <CellGroup inset v-for="(item,index) in list" :key="item" style="margin-top: 10px">
      <Cell class="my-cell-title">
        <template #title>
          <span style="color:var(--base-color);">{{ index + 1 }}</span>
          姓名：{{ item.name }}
        </template>
        <template #value>
          月份：{{ format(new Date(item.month), 'yyyy-MM') }}
        </template>
      </Cell>
      <div>
        <Grid :column-num="2" :border="false">
          <GridItem class="show-data-gridItem" :text="`部门:${item.departmentName}`"/>
          <GridItem class="show-data-gridItem" :text="`薪资:${item.base + item.performanceA + item.performanceB
          + item.pieceworkOneNew + item.pieceworkTwoNew + item.commissionTwoRenew
          + item.commissionOneAbove + item.commissionTwoAbove + item.commissionCustomization
          + item.commissionDesignCheck + item.otherReward + item.fullTime
          + item.otherDeduction + item.mistakeDeduction + item.leaveDeduction + item.otherSubsidies}`"/>
        </Grid>
      </div>
    </CellGroup>
  </List>

  <Popup v-model:show="show" position="bottom" :style="{ height: '30%' }" >
    <DatetimePicker
        v-model="currentDate"
        type="year-month"
        title="选择年月"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onConfirm"
        @cancel="show = false"
    />
  </Popup>
</template>

<script setup>
import {
  Cell,
  CellGroup,
  Field,
  Button,
  Tag,
  Icon,
  Toast,
  Col,
  Row,
  DatetimePicker ,
  Popup,
  List,
  Grid, GridItem
} from 'vant';
import {onMounted, reactive, ref} from "vue";
import format from "date-fns/format";
import {getSalaryPage} from "@/api/salary";

const minDate = ref(new Date(2021, 0, 1))
const maxDate = ref(new Date())

//分页相关
let pageNum = ref(1)
let pageSize = ref(10)

let SearchQuery = reactive({
  likeQuery: {month: ''},
})

const currentDate = ref(new Date());


const show = ref(false);
const onConfirm = (value) => {
  show.value = false;
  SearchQuery.likeQuery.month = formatDate(value);
};
const formatDate = (date) => {
  return format(new Date(date), 'yyyy-MM')
}


const list = ref([]);
const loading = ref(false);
const finished = ref(false);

const onLoad = () => {
  getSalaryPage(SearchQuery, pageNum.value, pageSize.value).then(res => {
    if (res.data.records.length > 0) {

      pageNum.value++;
      list.value.push(...res.data.records)
      // 加载状态结束
      loading.value = false;
    } else {
      finished.value = true;
    }
  })
}

const search = () => {
  pageNum.value=0
  list.value.splice(0, list.value.length)
  onLoad()
}


onMounted(() => {
  // load()
})
</script>

<style scoped>

</style>
